import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import GobalSearchState from './state';
import GlobalSearchMutations from './mutations';
import GlobalSearchGetters from './getters';
import { GlobalSearchService } from '../service';

const globalSearchService = new GlobalSearchService();

export default class GlobalSearchActions extends Actions<
  GobalSearchState,
  GlobalSearchGetters,
  GlobalSearchMutations,
  // eslint-disable-next-line no-use-before-define
  GlobalSearchActions
> {
  async get_search() {
    try {
      const { sortBy = [], sortDesc = [] } = this.state.table_options;
      const { current_page, limit } = this.state.pagination_props;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit,
          page: current_page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_SEARCH_LOADING(true);
      const { data, meta } = await globalSearchService.get_search(payload);

      this.mutations.SET_SEARCH_ITEMS(data.items);
      this.mutations.SET_PAGES(data.available_search_pages);
      this.mutations.SET_SEARCH(data.search);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_SEARCH_LOADING(false);
    }
  }
}
